const DELETED_PROP_CONTROLLER_TYPES = {
  List: "List",
  RichText: "RichText",
  Shape: "Shape",
  Typeahead: "Typeahead"
};
export {
  DELETED_PROP_CONTROLLER_TYPES
};
//# sourceMappingURL=deleted.js.map